import React, { useEffect, useState } from "react";
// import { WelcomeTweetModal } from "../modals/WelcomeTweetModal";
import { NavbarNew } from "./navbar";
import sec1Img from "../../images/homepage/sec1Img.png";
import sec4Img from "../../images/homepage/sec4Img.png";
import arrowRight from "../../images/homepage/arrowRight.svg";
import sec3Img1 from "../../images/homepage/sec3Img1.png";
import sec3Img2 from "../../images/homepage/sec3Img2.png";
import sec3Img3 from "../../images/homepage/sec3Img3.png";
import sec3Img4 from "../../images/homepage/sec3Img4.png";

import animation1sec1 from "../../images/homepage/animation1sec.mp4";
import animation1sec from "../../images/homepage/animation1sec.webm";
import Animation2sec1 from "../../images/homepage/Animation2sec1.webm";
import facebookIco from "../../images/homepage/facebookIco.svg";
import anouncementImg from "../../images/anouncement.png";

import { Link } from "react-router-dom";
import EducationalVideosNew from "./educationalContent";
import { Modal } from "react-bootstrap";
import { SocialModal } from "../modals/socialModal";
import userAction from "../../redux/users/action";
import { useDispatch, useSelector } from "react-redux";
import { useAlert } from "react-alert";
import copy from "copy-to-clipboard";
import api from "../../api";
import { AnnualModal } from "../modals/annualModal";
import { MonthlyModal } from "../modals/monthlyModal";
import { BroadcastModal } from "../modals/broadcastModal";
import { JoinBroadcastModal } from "../modals/joinBroadcastModal";
import Slider from "react-slick";
// Import css files
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import animate from "../../assets/js/animate";
import LiveBTCChart from "./btcChart";
import { BTCCalculator } from "../calculators/ifInvestCalculator";
import AwardWinningCarousel from "./AwardWinningCarousel";

// Convert a PKT time (HH:MM, 24h) to the viewer's local time string.
// Mirrors the mobile app's liveSession.js pktToLocal — Date methods without
// an explicit timeZone always resolve to the runtime's local timezone, so
// this works in the browser exactly like it does on-device, no geolocation
// needed.
const pktToLocal = (hh, mm) => {
  const now = new Date();
  const utc = new Date(
    Date.UTC(now.getFullYear(), now.getMonth(), now.getDate(), hh - 5, mm),
  );
  return utc.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};

// Same PKT conversion, but into a named IANA timezone instead of the
// viewer's own — used for the extra world-clock row on the Session
// Timings card. DST is handled automatically by toLocaleTimeString.
const pktToZone = (hh, mm, timeZone) => {
  const now = new Date();
  const utc = new Date(
    Date.UTC(now.getFullYear(), now.getMonth(), now.getDate(), hh - 5, mm),
  );
  return utc.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
    timeZone,
  });
};

const WORLD_ZONES = [
  { label: "New York", zone: "America/New_York" },
  { label: "London", zone: "Europe/London" },
  { label: "Sydney", zone: "Australia/Sydney" },
  { label: "India", zone: "Asia/Kolkata" },
];

const worldTimesFor = (hh, mm) =>
  WORLD_ZONES.map((z) => ({
    label: z.label,
    time: pktToZone(hh, mm, z.zone),
  }));

const PRESS_ITEMS = [
  {
    outlet: "Crypto Stories",
    tone: "#2563eb",
    bg: "#e8f0fe",
    date: "21 March 2022",
    title:
      "Crypto Stories: Pakistani crypto billionaire wants his country to be less reliant on credit",
    desc: "Waqar Zaka – Pakistan’s ex-crypto advisor and a winning leverage trader.",
    href: "https://www.youtube.com/watch?v=eZ0dFzxXTV4",
  },
  {
    outlet: "SAMAA",
    tone: "#895aef",
    bg: "#f2eefe",
    date: "14 April 2024",
    title: "Waqar Zaka makes millions amidst Bitcoin crash",
    desc: "Televised coverage of his trading results through the market downturn.",
    href: "https://www.samaa.tv/2087313031-waqar-zaka-makes-millions-amidst-crypto-market-turmoil",
  },
  {
    outlet: "Dunya Global",
    tone: "#059669",
    bg: "#e6f7f0",
    date: "30 Nov 2024",
    title: "Waqar Zaka continues his profit streak on cryptocurrency.",
    desc: "National news coverage of a sustained run of profitable trades.",
    href: "https://dunyanews.tv/amp/english/853790.php",
  },
];

const BRIEF_LANES = [
  {
    kicker: "Who teaches you",
    title: "Instructors",
    tone: "#895aef",
    bg: "#f2eefe",
    icon: (
      <svg
        width="22"
        height="22"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M4 5.5A1.5 1.5 0 0 1 5.5 4H10a2 2 0 0 1 2 2v13a2 2 0 0 0-2-2H5.5A1.5 1.5 0 0 1 4 15.5v-10Z" />
        <path d="M20 5.5A1.5 1.5 0 0 0 18.5 4H14a2 2 0 0 0-2 2v13a2 2 0 0 1 2-2h4.5a1.5 1.5 0 0 0 1.5-1.5v-10Z" />
      </svg>
    ),
    paras: [
      "Benefit from 7+ years of experience and the wisdom of our seasoned instructors who are dedicated to guiding and educating you.",
    ],
  },
  {
    kicker: "When we go live",
    title: "Available During Working Hours",
    tone: "#2563eb",
    bg: "#e8f0fe",
    icon: (
      <svg
        width="22"
        height="22"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="12" cy="12" r="9" />
        <path d="M12 7.2v5l3.2 2" />
      </svg>
    ),
    paras: [
      "Please note that our session timing has been changed.",
      "New Timing: 9:30 PM PKT & 10:30 PM PKT",
      "Days: Monday to Friday",
      "Please note: Sunday – No session.",
      // "Please note: Saturday and Sunday – No session.",
      "Thank you for your cooperation and happy learning!",
    ],
    slots: [
      ["MON", 1],
      ["TUE", 1],
      ["WED", 1],
      ["THU", 1],
      ["FRI", 1],
      ["SAT", 1],
      ["SUN", 0],
    ],
  },
  {
    kicker: "Read this first",
    title: "Warning",
    tone: "#ea6a1c",
    bg: "#fff1e6",
    icon: (
      <svg
        width="22"
        height="22"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M12 3.4 2.6 20h18.8L12 3.4Z" />
        <path d="M12 9.6v4.6M12 17.2h.01" />
      </svg>
    ),
    paras: [
      "Warning: As per 2024 data, only 6.8% of people worldwide are able to engage in and fully understand crypto work. Additionally, 80% to 90% of day traders end up in losses. Why? Because the majority are unwilling to practice demo trades before diving in. If you want to succeed, you must develop patience and focus on practicing trades with minimal investments rather than going all in. Smart and disciplined trading is the key to long term success in the volatile crypto market.",
    ],
    metrics: [
      { v: "6.8%", l: "fully understand crypto work", tone: "#ea6a1c", pct: 7 },
      {
        v: "80–90%",
        l: "of day traders end up in losses",
        tone: "#dc2626",
        pct: 85,
      },
      {
        v: "7+ yrs",
        l: "of instructor experience behind you",
        tone: "#059669",
        pct: 70,
      },
    ],
  },
];

const EDU_DURATION = 6000; // ms per auto-advance

const EDU_SERVICES = [
  {
    title: "Block Chain",
    copy: "Learn Blockchain and Revolutionize Possibilities Across Industries!",
    tone: "#7c3aed",
    ink: "#6d28d9",
    soft: "#f2eefe",
    media: "linear-gradient(150deg,#4c1d95,#1e1b4b)",
    image: sec3Img1,
    icon: (
      <svg
        width="21"
        height="21"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M12 2 4 6.5v11L12 22l8-4.5v-11L12 2Z" />
        <path d="m4 6.5 8 4.5 8-4.5M12 11v11" />
      </svg>
    ),
  },
  {
    title: "Market Data Analysis",
    copy: "Learn how data, mathematics and probability can be used to understand market behaviour.",
    tone: "#0e7490",
    ink: "#0f766e",
    soft: "#e2f6f7",
    media: "linear-gradient(150deg,#0e7490,#0b2c52)",
    image: sec3Img2,
    icon: (
      <svg
        width="21"
        height="21"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="m3 16 5-6 4 4 4-6 5 5" />
        <circle cx="8" cy="10" r="1.5" />
      </svg>
    ),
  },
  {
    title: "Probability & Risk Analysis",
    copy: "Dive into the World of Future Trading and Unlock Tomorrow's Profits Today",
    tone: "#2563eb",
    ink: "#1d4ed8",
    soft: "#e8f0fe",
    media: "linear-gradient(150deg,#1d4ed8,#0b1e40)",
    image: sec3Img3,
    icon: (
      <svg
        width="21"
        height="21"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M13 2 4.5 13.5H11l-1 8.5 8.5-11.5H12l1-8.5Z" />
      </svg>
    ),
  },
  {
    title: "Stocks & Commodities Research",
    copy: "Get Expert education by Team WZ. Learn & Grow!",
    tone: "#b45309",
    ink: "#b45309",
    soft: "#fdf1e0",
    media: "linear-gradient(150deg,#b45309,#3b1d05)",
    image: sec3Img4,
    icon: (
      <svg
        width="21"
        height="21"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M12 3v3M12 18v3M4.5 8h15l-3.2 4.6a4 4 0 0 1-3.3 1.7h-2a4 4 0 0 1-3.3-1.7L4.5 8Z" />
        <path d="M7 21h10" />
      </svg>
    ),
  },
];

export const HomeNew = () => {
  const userStore = useSelector((state) => state.userReducer);

  const { setUser } = userAction;
  const dispatch = useDispatch();
  const alert = useAlert();
  const [loader, setLoader] = useState(false);
  const [copyText, setCopyText] = useState("Copy to clipboard");
  const [walletInput, setWalletInput] = useState("");

  const [showMore, setShowMore] = useState(false);
  const handleCloseMore = () => setShowMore(false);
  const handleShowMore = () => setShowMore(true);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [showAddWallet, setShowAddWallet] = useState(false);
  const handleCloseAddWallet = () => setShowAddWallet(false);
  const handleShowAddWallet = () => setShowAddWallet(true);

  const [showBroadcast, setShowBroadcast] = useState(false);
  const handleCloseBroadcast = () => setShowBroadcast(false);
  const handleShowBroadcast = () => setShowBroadcast(true);

  const [showJoinBroadcast, setShowJoinBroadcast] = useState(false);

  const [openLane, setOpenLane] = useState(1);
  const toggleLane = (i) => {
    setOpenLane((prev) => (prev === i ? -1 : i));
  };

  const [activeService, setActiveService] = useState(0);
  const [eduAuto, setEduAuto] = useState(true);
  const [eduTick, setEduTick] = useState(0);

  const selectService = (i) => {
    setActiveService(i);
    setEduTick(0);
  };
  const nextService = () => {
    setActiveService((a) => (a + 1) % EDU_SERVICES.length);
    setEduTick(0);
  };
  const toggleEduAuto = () => {
    setEduAuto((a) => !a);
    setEduTick(0);
  };

  useEffect(() => {
    if (!eduAuto) return;
    const interval = setInterval(() => {
      setEduTick((t) => {
        const next = t + 120;
        if (next >= EDU_DURATION) {
          setActiveService((a) => (a + 1) % EDU_SERVICES.length);
          return 0;
        }
        return next;
      });
    }, 120);
    return () => clearInterval(interval);
  }, [eduAuto, activeService]);

  const [formSubmitted, setformSubmitted] = useState(false);
  const [showYearly, setShowYearly] = useState(false);
  const handleCloseYearly = () => {
    setShowYearly(false);
    setTimeout(() => {
      setformSubmitted(false);
    }, 1000);
  };
  const handleShowYearly = () => {
    setShowYearly(true);
    handleClose();
  };

  const [showMonthly, setShowMonthly] = useState(false);
  const handleCloseMonthly = () => {
    setShowMonthly(false);
    // handleShowBroadcast();
  };
  const handleShowMonthly = () => {
    setShowMonthly(true);
    handleClose();
  };

  const [showVideo, setShowVideo] = useState(false);
  const handleCloseVideo = () => {
    setShowVideo(false);
    // {!userStore?.users?.user?.name &&
    //   handleShowWallet(true)
    // }
    handleShowBroadcast();
  };

  const handleCopy = (text) => {
    copy(text);
    setCopyText("Copied");
    setTimeout(() => {
      setCopyText("Copy to clipboard");
    }, 3000);
  };

  const addWallet = async () => {
    try {
      if (!walletInput) {
        alert.show("Please add TRC wallet address");
        return;
      }
      setLoader(true);
      // let balance = await checkBalance(walletInput)
      // console.log(balance);

      // if(balance < 100) {
      //   alert.show("Your do not have enough balance to get VIP access")
      //   setLoader(false)
      //   return
      // }

      let payload = {
        _id: userStore?.users?.user?._id,
        wallet: walletInput,
      };

      const signalResponse = await api.userEdit(payload);
      // console.log(signalResponse);
      if (signalResponse?.success) {
        let updatedData = userStore?.users;
        updatedData.user.wallet = payload.wallet;
        dispatch(setUser(updatedData));
        handleCloseAddWallet();
        alert.show("Your Wallet Address Has Been Added");
        // navigate("/post")
      } else {
        alert.show(signalResponse?.msg);
      }
      setLoader(false);
    } catch (error) {
      console.log(error);
      // handleCloseAddWallet()
      alert.show(error.message);
      setLoader(false);
    }
  };

  useEffect(() => {
    // {!userStore?.users?.user?.name &&
    //   handleShowVideo()
    // }
    // {(userStore?.users?.user?.name && !userStore?.users?.user?.wallet) &&
    //   handleShowAddWallet()
    // }
  }, []);
  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 4000,
  };

  useEffect(() => {
    animate();
  }, []);
  return (
    <>
      <div className="homepageNew">
        <div className="homeSec1">
          <div className="container">
            {/* <Marquee /> */}

            <div className="row ai-center">
              <div className="col-lg-6">
                <div className="content">
                  <div className="tagline animatable slideInUp ">
                    FOR A BETTER FUTURE
                  </div>
                  <div className="heading animatable slideInUp animationDelay100">
                    Data <span>First</span>, Decisions <span>Follow</span>
                  </div>
                  <div className="disclaimer">
                    <p className="animatable slideInUp animationDelay100">
                      <b>Educating since 2016,</b> Waqar Zaka started posting
                      about Bitcoin when it was worth just <b>$268</b>.{" "}
                      <a
                        href="https://www.youtube.com/watch?v=6hK2tVHC3bo"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Click here to verify this
                      </a>
                      . You can compare his journey with other crypto
                      influencers. Waqar was among the first to start educating
                      people about Bitcoin when very few had knowledge about
                      cryptocurrency.
                    </p>
                    <div className="wzDisclaimerCard animatable slideInUp animationDelay100">
                      <p className="mb-0">
                        We are a{" "}
                        <b>
                          data-driven market research team focused on
                          mathematics, probability and decision-making
                        </b>
                        , but we still want to warn you: we cannot promise to
                        make you a millionaire.
                      </p>
                    </div>
                    <p className="animatable slideInUp animationDelay100">
                      We do not make any promises or guarantees regarding
                      profits, returns, or making you a millionaire. You are
                      solely responsible for your own trading decisions,
                      profits, and losses. We share our research, data,
                      mathematical models and personal decision-making
                      process.{" "}
                    </p>
                    <p className="animatable slideInUp ">
                      <span>DISCLAIMER: </span>
                      You are paying solely to access our content. We are not
                      your coach, teacher, or mentor. We are not financial
                      advisors, portfolio managers, or a fund. Our content
                      studies financial markets through data, mathematics,
                      probability and research.{" "}
                    </p>

                    {/* <p className="animatable slideInUp animationDelay100">
                      Becoming a millionaire depends on your{" "}
                      <b>own hard work, discipline, and destiny.</b> What we
                      provide are the tools, knowledge, and insights but your
                      success will always be the result of your own effort and
                      determination.
                    </p> */}
                    {/* <p className="animatable slideInUp animationDelay200">
                      We are not a university or a degree program and do not
                      claim to replace the value of studying at institutions
                      like Stanford, Harvard, Cambridge, or Oxford.{" "}
                    </p> */}
                    <div
                      className=" more cursor-pointer animatable slideInUp animationDelay300"
                      onClick={handleShowMore}
                    >
                      See More
                    </div>
                  </div>
                  <div className="socialModal ms-0 pb-0">
                    <div className="row">
                      <div className="col-6">
                        <MonthlySession handleShowMonthly={handleShowMonthly} />
                      </div>
                      <div className="col-6">
                        <a
                          className="annual socialL"
                          onClick={handleShowYearly}
                        >
                          <img src={facebookIco} alt="" />
                          Annual Group
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="social-modal-container">
                    {/* App Store Button */}
                    <a
                      href="https://apps.apple.com/us/app/waqar-zaka/id6763535854"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="store-link"
                    >
                      <button className="store-btn app-store-btn">
                        <img
                          src="https://upload.wikimedia.org/wikipedia/commons/f/fa/Apple_logo_black.svg"
                          alt="Apple"
                          className="store-icon icon-invert"
                        />
                        Get it on App Store
                      </button>
                    </a>

                    {/* Play Store Button */}
                    <a
                      href="https://play.google.com/store/apps/details?id=com.godzillaapp.wz"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="store-link"
                    >
                      <button className="store-btn play-store-btn">
                        <img
                          src="https://upload.wikimedia.org/wikipedia/commons/thumb/2/2f/Google_Play_2022_icon.svg/120px-Google_Play_2022_icon.svg.png"
                          alt="Android"
                          className="store-icon"
                        />
                        Get it on Play Store
                      </button>
                    </a>
                  </div>
                  <div className="explore" onClick={handleShow}>
                    {/* <div className="text">Explore Our Channels</div> */}
                    <div className="text">Watch Waqar Zaka Trades</div>
                    <div className="next">
                      <img src={arrowRight} alt="mext" />
                    </div>
                  </div>
                  <div
                    className="explore"
                    onClick={() => setShowJoinBroadcast(true)}
                  >
                    <div className="text">
                      Join Waqar Zaka Broadcast Channels
                    </div>
                    <div className="next">
                      <img src={arrowRight} alt="broadcast" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="imgDiv logo">
                  <video
                    playsInline
                    webkit-playsinline
                    controls={false}
                    src={Animation2sec1}
                    autoPlay
                    loop
                    muted
                    className="w-100 "
                  />
                </div>
                <div className="sessionTimingCard animatable slideInUp animationDelay100">
                  <div className="stc-glow" />
                  <div className="stc-header">
                    <div className="stc-icon">
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <circle cx="12" cy="12" r="9" />
                        <path d="M12 7.5v5l3.2 2" />
                      </svg>
                    </div>
                    <div className="stc-heading">
                      <span className="stc-title">Watch LIVE Trading</span>
                      <span className="stc-sub">Pakistan Standard Time</span>
                    </div>
                  </div>

                  <div className="stc-chips">
                    <div className="stc-chip">
                      <span className="stc-chip-time">
                        09:30<small>PM</small>
                      </span>
                      <span className="stc-chip-local">
                        {pktToLocal(21, 30)} Your Local Time
                      </span>
                      <div className="stc-chip-world">
                        {worldTimesFor(21, 30).map((w) => (
                          <div className="stc-chip-world-item" key={w.label}>
                            <span>{w.label}</span>
                            <b>{w.time}</b>
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className="stc-chip">
                      <span className="stc-chip-time">
                        10:30<small>PM</small>
                      </span>
                      <span className="stc-chip-local">
                        {pktToLocal(22, 30)} Your Local Time
                      </span>
                      <div className="stc-chip-world">
                        {worldTimesFor(22, 30).map((w) => (
                          <div className="stc-chip-world-item" key={w.label}>
                            <span>{w.label}</span>
                            <b>{w.time}</b>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>

                  <div className="stc-days">
                    <span className="stc-day active">M</span>
                    <span className="stc-day active">T</span>
                    <span className="stc-day active">W</span>
                    <span className="stc-day active">T</span>
                    <span className="stc-day active">F</span>
                    <span className="stc-day special">S</span>
                    <span className="stc-day off">S</span>
                  </div>

                  <div className="stc-callout">
                    <div className="stc-callout-icon">
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M12 2 14.6 8.8 22 9.4 16.5 14 18.2 21 12 17.3 5.8 21 7.5 14 2 9.4 9.4 8.8Z" />
                      </svg>
                    </div>
                    <div>
                      <span className="stc-callout-label">
                        Saturday special
                      </span>
                      <p>
                        Live sessions at <b>8:30 PM PKT</b>{" "}
                        <span className="local">
                          ({pktToLocal(20, 30)} Your Local Time)
                        </span>{" "}
                        and <b>10:00 PM PKT</b>{" "}
                        <span className="local">
                          ({pktToLocal(22, 0)} Your Local Time)
                        </span>{" "}
                        — join us to stay updated and connected.
                      </p>
                    </div>
                  </div>

                  <div className="stc-footer">
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M4 12.5 9 17.5 20 6.5" />
                    </svg>
                    Sunday — no session. <b>Thank you for staying with us!</b>
                  </div>
                </div>
                {/* <Slider {...settings}>
                  <div className="imgDiv">
                    <video
                      playsInline
                      webkit-playsinline
                      controls={false}
                      src={animation1sec}
                      autoPlay
                      loop
                      muted
                      className="w-100"
                    />
                  </div>
                  <div className="imgDiv">
                    <video
                      playsInline
                      webkit-playsinline
                      controls={false}
                      src={animation1sec1}
                      autoPlay
                      loop
                      muted
                      className="w-100"
                    />
                  </div>
                </Slider> */}
              </div>
            </div>

            {/* <Marquee2 /> */}
          </div>
        </div>

        <AwardWinningCarousel />

        <section className="wzBrief">
          <div className="container">
            <div className="wzBrief-head">
              <div>
                <div className="wzBrief-eyebrow">
                  <i></i>Program Briefing
                </div>
                <h2 className="wzBrief-h2">
                  Before You <span>Begin</span>
                </h2>
              </div>
              <div className="wzBrief-counter">
                <i></i>
                <span>
                  {openLane >= 0
                    ? `${String(openLane + 1).padStart(2, "0")} / ${String(
                        BRIEF_LANES.length,
                      ).padStart(2, "0")} open`
                    : `${BRIEF_LANES.length} sections`}
                </span>
              </div>
            </div>

            <div className="wzBrief-lanes">
              {BRIEF_LANES.map((lane, i) => {
                const isOpen = openLane === i;
                return (
                  <div
                    className={isOpen ? "wzBrief-lane is-open" : "wzBrief-lane"}
                    key={lane.title}
                  >
                    <button
                      type="button"
                      className="wzBrief-lane-btn"
                      onClick={() => toggleLane(i)}
                    >
                      <span className="wzBrief-idx">
                        {String(i + 1).padStart(2, "0")}
                      </span>
                      <span
                        className="wzBrief-ico"
                        style={{ color: lane.tone, background: lane.bg }}
                      >
                        {lane.icon}
                      </span>
                      <span style={{ flex: 1, minWidth: 0 }}>
                        <span className="wzBrief-kicker">{lane.kicker}</span>
                        <span className="wzBrief-title">{lane.title}</span>
                      </span>
                      <span className="wzBrief-caret">
                        <i className="fa-solid fa-chevron-down" />
                      </span>
                    </button>

                    {isOpen && (
                      <div className="wzBrief-body">
                        <div className="wzBrief-divider"></div>
                        <div className="wzBrief-paras">
                          {lane.paras.map((p, pi) => (
                            <p key={pi}>{p}</p>
                          ))}
                        </div>

                        {lane.slots && (
                          <div className="wzBrief-slots">
                            {lane.slots.map(([label, on]) => (
                              <span
                                key={label}
                                className={
                                  on ? "wzBrief-slot on" : "wzBrief-slot off"
                                }
                              >
                                {label}
                              </span>
                            ))}
                          </div>
                        )}

                        {lane.metrics && (
                          <div className="wzBrief-metrics">
                            {lane.metrics.map((m) => (
                              <div className="wzBrief-metric" key={m.l}>
                                <div className="v" style={{ color: m.tone }}>
                                  {m.v}
                                </div>
                                <div className="l">{m.l}</div>
                                <div className="track">
                                  <div
                                    className="fill"
                                    style={{
                                      width: `${m.pct}%`,
                                      background: `linear-gradient(90deg, ${m.tone}88, ${m.tone})`,
                                    }}
                                  ></div>
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        <section className="wzPress">
          <div className="container">
            <div className="wzPress-head">
              <div className="wzPress-eyebrow">
                <i></i>Press Record
              </div>
              <h2 className="wzPress-h2">
                Team <span>Acknowledgements</span>
              </h2>
              <div className="wzPress-rule"></div>
            </div>

            <div className="wzPress-timeline-wrap">
              <div className="wzPress-rail">
                <span></span>
              </div>
              <div className="wzPress-timeline">
                {PRESS_ITEMS.map((item, i) => (
                  <div className="wzPress-item" key={item.title}>
                    <div className="wzPress-marker">
                      <span className="shell">
                        <span
                          className="ping"
                          style={{
                            background: item.tone,
                            animationDelay: `${(i * 0.5).toFixed(1)}s`,
                          }}
                        ></span>
                        <span
                          className="dot"
                          style={{
                            background: item.tone,
                            boxShadow: `0 0 12px ${item.tone}99`,
                          }}
                        ></span>
                      </span>
                    </div>
                    <a
                      className="wzPress-node"
                      href={item.href}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span
                        className="wzPress-stub"
                        style={{
                          background: `linear-gradient(180deg, ${item.tone}, ${item.tone}55)`,
                        }}
                      ></span>
                      <div className="top">
                        <span
                          className="wzPress-outlet"
                          style={{ color: item.tone, background: item.bg }}
                        >
                          {item.outlet}
                        </span>
                        <span className="wzPress-date">{item.date}</span>
                      </div>
                      <h3>{item.title}</h3>
                      {item.desc && <p>{item.desc}</p>}
                      <span className="wzPress-more">
                        Learn More{" "}
                        <span className="wzPress-arrow">
                          <i className="fa-solid fa-arrow-right" />
                        </span>
                      </span>
                    </a>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <div className="container">
          <section className="wzEdu" id="services">
            <div className="wzEdu-gridbg"></div>
            <div className="wzEdu-orb o1"></div>
            <div className="wzEdu-orb o2"></div>

            <div className="wzEdu-wrap">
              <div className="wzEdu-head">
                <div className="wzEdu-pill">
                  <i></i>Four learning tracks
                </div>
                <h2 className="wzEdu-h2">
                  Explore Our
                  <br />
                  <span>Education Services</span>
                </h2>
                <div className="wzEdu-rule"></div>
              </div>

              <div className="wzEdu-split">
                <div className="wzEdu-rail">
                  <div className="wzEdu-tabs">
                    {EDU_SERVICES.map((s, i) => {
                      const isOn = i === activeService;
                      const progressPct = isOn
                        ? eduAuto
                          ? (eduTick / EDU_DURATION) * 100
                          : 100
                        : 0;
                      return (
                        <button
                          key={s.title}
                          type="button"
                          className={isOn ? "wzEdu-tab is-on" : "wzEdu-tab"}
                          style={{
                            animationDelay: `${(i * 0.07).toFixed(2)}s`,
                            background: isOn
                              ? "linear-gradient(120deg,#ffffff,#faf8ff)"
                              : "rgba(255,255,255,.7)",
                            borderColor: isOn ? `${s.tone}66` : "#eeebf6",
                            boxShadow: isOn
                              ? `0 18px 44px ${s.tone}26`
                              : "0 3px 14px rgba(31,20,66,.04)",
                          }}
                          onClick={() => selectService(i)}
                        >
                          <span className="wzEdu-tab-row">
                            <span
                              className="wzEdu-tico"
                              style={{
                                background: isOn ? s.tone : s.soft,
                                color: isOn ? "#fff" : s.ink,
                                boxShadow: isOn
                                  ? `0 10px 24px ${s.tone}55`
                                  : "none",
                              }}
                            >
                              {s.icon}
                            </span>
                            <span className="wzEdu-tab-txt">
                              <span className="wzEdu-tab-idx">0{i + 1}</span>
                              <span className="wzEdu-tab-ttl">{s.title}</span>
                            </span>
                            <span
                              className="wzEdu-tab-mark"
                              style={{ color: isOn ? s.ink : "#c4bfd4" }}
                            >
                              {isOn ? "●" : "→"}
                            </span>
                          </span>
                          {isOn && (
                            <span className="wzEdu-track">
                              <i
                                style={{
                                  width: `${progressPct}%`,
                                  background: `linear-gradient(90deg, ${s.tone}88, ${s.tone})`,
                                }}
                              ></i>
                            </span>
                          )}
                        </button>
                      );
                    })}
                  </div>

                  <div className="wzEdu-auto">
                    <span className="spin"></span>
                    <span className="lbl">
                      {eduAuto ? "Auto-cycling tracks" : "Auto-cycle paused"}
                    </span>
                    <button type="button" onClick={toggleEduAuto}>
                      {eduAuto ? "Pause" : "Play"}
                    </button>
                  </div>
                </div>

                <div
                  className="wzEdu-panel"
                  key={activeService}
                  style={{
                    border: `1px solid ${EDU_SERVICES[activeService].tone}33`,
                    boxShadow: `0 26px 66px ${EDU_SERVICES[activeService].tone}1f`,
                  }}
                >
                  <div className="wzEdu-mediawrap">
                    <div
                      className="wzEdu-media"
                      style={{ background: EDU_SERVICES[activeService].media }}
                    >
                      <img
                        src={EDU_SERVICES[activeService].image}
                        alt={EDU_SERVICES[activeService].title}
                      />
                      <span className="mesh"></span>
                      <span className="scan"></span>
                    </div>
                    <span
                      className="wzEdu-trackchip"
                      style={{
                        background: EDU_SERVICES[activeService].tone,
                        boxShadow: `0 10px 24px ${EDU_SERVICES[activeService].tone}66`,
                      }}
                    >
                      Service 0{activeService + 1} of 0{EDU_SERVICES.length}
                    </span>
                  </div>
                  <div className="wzEdu-body">
                    <h3>{EDU_SERVICES[activeService].title}</h3>
                    <p>{EDU_SERVICES[activeService].copy}</p>
                    <div className="wzEdu-actions">
                      <Link
                        to="/signup"
                        className="wzEdu-cta"
                        style={{
                          background: `linear-gradient(135deg, ${EDU_SERVICES[activeService].tone}cc, ${EDU_SERVICES[activeService].ink})`,
                          boxShadow: `0 16px 38px ${EDU_SERVICES[activeService].tone}55`,
                        }}
                      >
                        <span className="shine"></span>
                        <span className="l">Start This Track</span>
                        <span className="l wzEdu-arrow">
                          <i className="fa-solid fa-arrow-right" />
                        </span>
                      </Link>
                      <button
                        type="button"
                        className="wzEdu-next"
                        onClick={nextService}
                      >
                        Next Service
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>

        <div className="container">
          <BTCCalculator />
        </div>

        <div className="container">
          <section className="wzAbout" id="about">
            <div className="wzAbout-gridbg"></div>
            <div className="wzAbout-orb o1"></div>
            <div className="wzAbout-orb o2"></div>

            <div className="wzAbout-wrap">
              <div className="wzAbout-head">
                <div className="wzAbout-eyebrow">
                  <i></i>Who We Are
                </div>
                <h2>About</h2>
                <div className="wzAbout-rule"></div>
              </div>

              <div className="wzAbout-grid">
                <div>
                  <p className="wzAbout-lede">
                    <strong>We are a research team</strong> exploring blockchain
                    and financial markets through data, mathematics and
                    probability. Our goal is to equip you with data analysis,
                    quantitative research and probability models to help you
                    stay ahead in the crypto space.
                  </p>

                  <div className="wzAbout-tag">
                    <span></span>
                    <span>Understand the Data. Make Your Own Decisions.</span>
                  </div>

                  <div className="wzAbout-pillars">
                    <div className="wzAbout-pillar">
                      <span
                        className="wzAbout-pico"
                        style={{ color: "#895aef", background: "#f2eefe" }}
                      >
                        <svg
                          width="17"
                          height="17"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path d="M12 2 4 6.5v11L12 22l8-4.5v-11L12 2Z" />
                          <path d="m4 6.5 8 4.5 8-4.5M12 11v11" />
                        </svg>
                      </span>
                      <div className="k">Blockchain</div>
                      <div className="v">Deep Research</div>
                    </div>
                    <div className="wzAbout-pillar">
                      <span
                        className="wzAbout-pico"
                        style={{ color: "#2563eb", background: "#e8f0fe" }}
                      >
                        <svg
                          width="17"
                          height="17"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path d="m3 16 5-6 4 4 4-6 5 5" />
                          <circle cx="8" cy="10" r="1.5" />
                        </svg>
                      </span>
                      <div className="k">Data</div>
                      <div className="v">Live Analysis</div>
                    </div>
                    <div className="wzAbout-pillar">
                      <span
                        className="wzAbout-pico"
                        style={{ color: "#059669", background: "#e6f7f0" }}
                      >
                        <svg
                          width="17"
                          height="17"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path d="M12 3 5 6v5.5c0 4.2 2.9 7.6 7 9.5 4.1-1.9 7-5.3 7-9.5V6l-7-3Z" />
                          <path d="m9 12 2.2 2.2L15.5 10" />
                        </svg>
                      </span>
                      <div className="k">Probability</div>
                      <div className="v">Risk Analysis</div>
                    </div>
                  </div>

                  <div className="wzAbout-note">
                    <div className="inner">
                      <span className="ic">
                        <svg
                          width="17"
                          height="17"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <circle cx="12" cy="12" r="9" />
                          <path d="M12 8h.01M11 12h1v4h1" />
                        </svg>
                      </span>
                      <p>
                        While we share in-depth market research and quantitative
                        analysis, we are not financial advisors. Our analysis is
                        based on research and industry trends, empowering you to
                        make informed decisions.
                      </p>
                    </div>
                  </div>

                  <Link className="wzAbout-cta" to={"/signup"}>
                    <span className="wzAbout-shine"></span>
                    <span className="label">
                      Enroll Now{" "}
                      <span className="wzAbout-arrow">
                        <svg
                          width="15"
                          height="15"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2.4"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path d="M5 12h14M13 6l6 6-6 6" />
                        </svg>
                      </span>
                    </span>
                  </Link>
                </div>

                <div className="wzAbout-visual-wrap">
                  <div className="wzAbout-beam"></div>

                  <div className="wzAbout-ring outer">
                    <span
                      className="wzAbout-node top"
                      style={{ color: "#895aef" }}
                    >
                      <svg
                        width="17"
                        height="17"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M12 2v4M12 18v4M4.9 4.9l2.9 2.9M16.2 16.2l2.9 2.9M2 12h4M18 12h4M4.9 19.1l2.9-2.9M16.2 7.8l2.9-2.9" />
                      </svg>
                    </span>
                    <span
                      className="wzAbout-node bottom"
                      style={{ color: "#2563eb" }}
                    >
                      <svg
                        width="17"
                        height="17"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M3 17.5 9 11l4 4 7.5-8.5" />
                        <circle cx="9" cy="11" r="1.4" />
                      </svg>
                    </span>
                    <span
                      className="wzAbout-node right"
                      style={{ color: "#f59e0b" }}
                    >
                      <svg
                        width="17"
                        height="17"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M12 3v18M8 7h6.5a2.75 2.75 0 0 1 0 5.5H8h7a2.75 2.75 0 0 1 0 5.5H8" />
                      </svg>
                    </span>
                  </div>

                  <div className="wzAbout-ring inner">
                    <span
                      className="wzAbout-node top"
                      style={{ color: "#059669" }}
                    >
                      <svg
                        width="17"
                        height="17"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M20 6 9 17l-5-5" />
                      </svg>
                    </span>
                    <span
                      className="wzAbout-node bottom"
                      style={{ color: "#895aef" }}
                    >
                      <svg
                        width="17"
                        height="17"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M12 3a6 6 0 0 1 3.5 10.9V16a1.5 1.5 0 0 1-1.5 1.5h-4A1.5 1.5 0 0 1 8.5 16v-2.1A6 6 0 0 1 12 3Z" />
                        <path d="M9.5 20.5h5" />
                      </svg>
                    </span>
                  </div>

                  <div className="wzAbout-visual">
                    <div className="wzAbout-frame">
                      <img src={sec4Img} alt="" className="w-100" />
                    </div>

                    <div className="wzAbout-chip tl">
                      <span style={{ color: "#059669", display: "flex" }}>
                        <svg
                          width="15"
                          height="15"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2.2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path d="M20 6 9 17l-5-5" />
                        </svg>
                      </span>
                      <span className="mono">Verified Research</span>
                    </div>

                    <div className="wzAbout-chip br">
                      <span className="badge">
                        <svg
                          width="15"
                          height="15"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="1.9"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <circle cx="12" cy="12" r="9" />
                          <path d="M12 7v5l3 2" />
                        </svg>
                      </span>
                      <span>
                        <span className="k">DATA UPDATES</span>
                        <span className="v">every 30 min</span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>

        <div className="container">
          <TelegramUpdates />
        </div>

        <div className="container">
          <div className="btcLiveChart">
            <LiveBTCChart heading={true} />
          </div>
        </div>

        {/* <section className="homeSec5">
          <div className="container">
            <div className="homeHeading">Our educational content</div>
            <EducationalVideosNew />
            <div className="text-center mt-4">
              <Link className="themeBlackBtn" to={"/signup"}>
                Enroll Now
              </Link>
            </div>
          </div>
        </section> */}

        {/* ── Contact Us Section ── */}
        <section className="homeContact" id="contact">
          <div className="container">
            <div className="homeContact-inner">
              <div className="homeContact-tag">GET IN TOUCH</div>
              <h2 className="homeContact-heading">
                Contact <span>Us</span>
              </h2>
              <p className="homeContact-sub">
                We're here to help. If you have any questions, need technical
                assistance, or require support with your account, our team is
                ready to assist you.
              </p>

              <div className="homeContact-cards">
                {/* Live Chat */}
                <div className="homeContact-card">
                  <div className="homeContact-card-icon">
                    <i className="fa-regular fa-comment-dots"></i>
                  </div>
                  <h3 className="homeContact-card-title">Live Chat</h3>
                  <p className="homeContact-card-text">
                    For faster assistance, use the live chat box available on
                    our website to connect directly with one of our support team
                    members during support hours.
                  </p>
                  <div className="homeContact-card-badge">
                    Available on Website
                  </div>
                </div>

                {/* Email Support */}
                <div className="homeContact-card">
                  <div className="homeContact-card-icon">
                    <i className="fa-regular fa-envelope"></i>
                  </div>
                  <h3 className="homeContact-card-title">Email Support</h3>
                  <p className="homeContact-card-text">
                    You can reach our support team anytime. We aim to respond to
                    all inquiries as quickly as possible.
                  </p>
                  <a
                    href="mailto:info@waqarzaka.net"
                    className="homeContact-email-link"
                  >
                    <i className="fa-solid fa-paper-plane"></i>
                    info@waqarzaka.net
                  </a>
                </div>
              </div>

              <p className="homeContact-footer-text">
                We appreciate your trust in{" "}
                <span className="homeContact-brand">WaqarZaka.net</span> and
                look forward to assisting you.
              </p>
            </div>
          </div>
        </section>

        {/* <div className="container">
          <section className="homeSec6" id="testimonial">
            <div className="row">
              <div className="col-lg-6">
                <div className="imgdiv">
                  <div className="icon active">
                    <img src={review1} alt="" />
                  </div>
                  <div className="icon one">
                    <img src={review2} alt="" />
                  </div>
                  <div className="icon two">
                    <img src={review3} alt="" />
                  </div>
                  <div className="icon three">
                    <img src={review2} alt="" />
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="reviewIco">
                  <img src={reviewIco} alt="" />
                </div>
                <div className="desc">
                  Since 1985 Reed has pioneered specialist recruitment, Sourcing
                  knowledgeable, skilled professionals pioneered Specialist
                  recruitment, sourcing.
                </div>
                <div className="nameM">
                  <div className="name">Victoria Wotton</div>
                  <div>
                    <div className="desig">Fementum Odio Co.</div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div> */}
      </div>

      <Modal size="lg" show={showMore} onHide={handleCloseMore} centered>
        <Modal.Body>
          <div className="otpModalMain broadcastModal">
            <div className="closeIcon" onClick={handleCloseMore}>
              <i className="fa-solid fa-xmark" />
            </div>

            <div className="showMoreModalM">
              <div className="showMoreModal py-4">
                <p className="desc1">
                  Becoming a millionaire depends on your{" "}
                  <b>own hard work, discipline, and destiny.</b> What we provide
                  are the tools, knowledge, and insights but your success will
                  always be the result of your own effort and determination.
                </p>
                <p className="desc1">
                  We are not a university or a degree program and do not claim
                  to replace the value of studying at institutions like
                  Stanford, Harvard, Cambridge, or Oxford.{" "}
                </p>
                <p className="desc1">
                  Our course is based on insights from renowned books, including
                  Misbehaving by Richard H. Thaler (Nobel Prize winner), Inside
                  the Investor’s Brain by Richard L. Peterson, Adaptive Markets
                  by Andrew W. Lo, and Thinking, Fast and Slow by Daniel
                  Kahneman (Nobel Prize winner). We also take inspiration from
                  Stanford University’s FINANCE 305: Capital Markets and
                  Institutional Investing and Bloomberg Terminal for market data
                  analysis.
                </p>
                <p className="desc1">
                  By joining our paid program, you will gain access to real-time
                  investment insights from Waqar Zaka, a day trader and
                  early-stage investor in crypto projects. Some days, you may
                  see multiple spot and futures trades; other times, there may
                  be no trades for weeks, it all depends on market conditions.
                  There is no fixed schedule for trades, and this is not a
                  signal group. Waqar Zaka shares where he is investing, and you
                  must make your own decisions based on your financial knowledge
                  and risk tolerance.
                </p>
                <p className="desc1">
                  Important: We will never ask you to send money to us or any
                  individual claiming to be Waqar Zaka. We are an educational
                  platform, not portfolio managers. If you seek portfolio
                  management services, consider professional firms like
                  BlackRock USA.
                </p>
                <p>
                  No Refund Policy: There are no refunds under any
                  circumstances. It is your responsibility to thoroughly
                  research before purchasing a subscription. This paid service
                  only provides exclusive content on where and how Waqar Zaka is
                  investing, it does not guarantee profits. No one in the world
                  can guarantee returns; if someone claims otherwise, they are
                  scammers. If guaranteed profits were possible, firms like
                  BlackRock would advertise them yet they don’t, because such
                  guarantees do not exist.
                </p>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal show={showAddWallet} onHide={handleCloseAddWallet} centered>
        <Modal.Body>
          <div className="otpModalMain">
            <div className="closeIcon" onClick={handleCloseAddWallet}>
              <i className="fa-solid fa-xmark" />
            </div>

            {/* <h3 className="title color-dark mb-0">For VIP Access</h3> */}
            {/* <p className="teather mb-0 text-center">Please add TRC Wallet Address</p> */}
            {/* <p className='mt-2'>Please note: Access to VIP services requires a minimum wallet balance of 100 USDT. If your balance is below this amount, you will not be able to access VIP services.</p> */}
            <h3 className="title color-dark mb-0">For Copy Trade</h3>
            <p className="mt-2">
              Do you want to copy Waqar Zaka's trades? If yes, then provide the
              address of your USDT (TRC) wallet with a balance of 100 USDT.
            </p>
            <div className="form-group my-4">
              <input
                type="text"
                onChange={(e) => setWalletInput(e.target.value)}
                className="form-control"
                placeholder="Address..."
              />
            </div>
            <div className="text-center">
              <button
                className="default-btn loaderBtn"
                disabled={loader ? true : false}
                onClick={addWallet}
              >
                {loader && <i className="fa fa-spinner fa-pulse mx-2"></i>}
                Add Wallet
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <AnnualModal
        show={showYearly}
        handleClose={handleCloseYearly}
        formSubmitted={formSubmitted}
        setformSubmitted={setformSubmitted}
      />

      <MonthlyModal
        showMonthly={showMonthly}
        handleCloseMonthly={handleCloseMonthly}
      />

      <BroadcastModal
        showBroadcast={showBroadcast}
        handleCloseBroadcast={handleCloseBroadcast}
      />
      <JoinBroadcastModal
        show={showJoinBroadcast}
        onHide={() => setShowJoinBroadcast(false)}
      />

      <SocialModal show={show} handleClose={handleClose} />
      {/* <WelcomeTweetModal /> */}
    </>
  );
};

const TelegramUpdates = () => {
  /* ===== Telegram (Waqar Zaka) ===== */

  const [tgData, setTgData] = useState([]);
  const TG_USERNAMES = ["waqarzaka", "WaqarZaka", "Waqar_Zaka"];
  var tgTimer = null;

  function timeAgo(ts) {
    var d = ts instanceof Date ? ts : new Date(ts),
      s = Math.floor((Date.now() - d) / 1000);
    if (s < 60) return s + "s ago";
    var m = Math.floor(s / 60);
    if (m < 60) return m + "m ago";
    var h = Math.floor(m / 60);
    if (h < 24) return h + "h ago";
    var dd = Math.floor(h / 24);
    return dd + "d ago";
  }
  const trunc = (s, n) =>
    s && s.length > n ? s.slice(0, n - 1) + "…" : s || "";

  function refreshTelegram() {
    fetchTelegramOnce(TG_USERNAMES)
      .then(renderTelegram)
      .catch(() => {
        let tgTicker = document.getElementById("tg-ticker");
        tgTicker.innerText = "Unable to load Telegram.";
      });
  }

  function startTelegramLoop() {
    if (tgTimer) clearInterval(tgTimer);
    refreshTelegram();
    tgTimer = setInterval(refreshTelegram, 120000);
  }

  function fetchTelegramOnce(usernames, idx = 0) {
    if (idx >= usernames.length) return Promise.resolve([]);
    var u = usernames[idx];
    return fetchFeedRaw("https://t.me/s/" + encodeURIComponent(u))
      .then((html) => {
        var items = parseTelegramHTML(html, u);
        if (items.length) return items;
        return fetchTelegramOnce(usernames, idx + 1);
      })
      .catch(() => fetchTelegramOnce(usernames, idx + 1));
  }

  function fetchFeedRaw(u) {
    var p1 = "https://api.allorigins.win/raw?url=" + encodeURIComponent(u),
      p2 = "https://api.allorigins.space/raw?url=" + encodeURIComponent(u);
    return fetch(p1)
      .then((r) => {
        if (!r.ok) throw 0;
        return r.text();
      })
      .catch(() => fetch(p2).then((r) => r.text()));
  }

  function renderTelegram(items) {
    // var el = $("tg-ticker");
    var el = document.getElementById("tg-ticker");
    if (!items.length) {
      el.innerHTML = `<span class="anounce"><img src=${anouncementImg} /></span> <span class="tag"><i class="fa-brands fa-telegram" ></i></span> No recent messages found.`;
      return;
    }
    setTgData(items);
    // el.innerHTML = items
    //   .map(
    //     (it) =>
    //       `<div class="tg-item"><span class="anounce"><img src=${anouncementImg} /></span> <span class="tag"><i class="fa-brands fa-telegram" ></i></span>` +
    //       '<a href="' +
    //       it.link.replace(/"/g, "&quot;") +
    //       '" target="_blank" rel="noopener">' +
    //       trunc(it.text, 140) +
    //       "</a>" +
    //       '<span class="tg-meta"> (' +
    //       timeAgo(it.date) +
    //       ")</span></div>"
    //   )
    //   .join("");
  }

  function refreshTelegram() {
    fetchTelegramOnce(TG_USERNAMES)
      .then(renderTelegram)
      .catch(() => {
        let tgTicker = document.getElementById("tg-ticker");

        tgTicker.innerText = "Unable to load Telegram.";
      });
  }

  function startTelegramLoop() {
    if (tgTimer) clearInterval(tgTimer);
    refreshTelegram();
    tgTimer = setInterval(refreshTelegram, 120000);
  }

  function parseTelegramHTML(html, usernameTried) {
    var out = [];
    try {
      var doc = new DOMParser().parseFromString(html, "text/html");
      var blocks = doc.querySelectorAll(".tgme_widget_message_wrap");
      blocks.forEach((b) => {
        var textEl = b.querySelector(".tgme_widget_message_text");
        var dateA = b.querySelector("a.tgme_widget_message_date");
        var timeEl = dateA ? dateA.querySelector("time") : null;
        var href = dateA ? dateA.getAttribute("href") : "";
        var dt = timeEl ? timeEl.getAttribute("datetime") : "";
        var txt = textEl ? textEl.textContent.trim() : "";
        if (txt) {
          out.push({
            text: txt.replace(/\s+/g, " ").trim(),
            link: href || "https://t.me/" + usernameTried,
            date: dt ? new Date(dt) : new Date(),
          });
        }
      });
    } catch (e) {}
    out.sort((a, b) => +b.date - +a.date);
    return out.slice(0, 3);
  }

  const getHeading = (str) => {
    return str.split(" ").slice(0, 3).join(" ");
  };

  useEffect(() => {
    startTelegramLoop();
  }, []);

  return (
    <>
      <div className="telegramUpdateSec">
        {/* <div className="lNews animatable slideInUp ">Latest News</div> */}
        <div className="headRow">
          <h1 className="homeHeading animatable slideInRight ">
            Waqar Zaka Telegram Updates.
          </h1>
          <a
            href="https://t.me/waqarzaka"
            target="_blank"
            className="btn followBtn animatable slideInLeft "
          >
            Follow Us On Telegram
          </a>
        </div>
        {tgData.length > 0 ? (
          <div className="row">
            {tgData.map((item, key) => (
              <div className="col-lg-4 col-sm-6 mb-3" key={key}>
                <a
                  href={item?.link.replace(/"/g, "&quot;")}
                  target="_blank"
                  className="newsCard "
                >
                  <div className="title">
                    {item?.text && getHeading(item?.text)}
                  </div>
                  <div className="desc">{trunc(item?.text, 100)}</div>
                  <div className="readRow">
                    <div className="d-flex ai-center">
                      <div className="text">Read More</div>
                      <div className="icon">
                        <i className="fa-solid fa-arrow-right-long"></i>
                      </div>
                    </div>
                    <div className="time">
                      {item?.date && timeAgo(item?.date)}
                    </div>
                  </div>
                </a>
              </div>
            ))}
          </div>
        ) : (
          <div id="strip">
            <div className="strip-row">
              <div id="news-ticker" className=""></div>
              <div id="tg-ticker" className=""></div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

const Marquee = () => {
  const content =
    "📢 LIVE SESSIONS will now be held at 09:30 PM and 10:30 PM Pakistan Standard Time, from Monday to Friday. There will be no sessions on Sunday. Kindly ensure your availability accordingly. We’re pleased to announce that live sessions will now also be held on Saturdays at 8:30 PM and 10:00 PM join us to stay updated and connected.";
  // "📢 Important: No Live Sessions on 25 & 26 June 2026 due to 9th & 10th Muharram (Ashura). Regular sessions will resume from 27 June 2026. Thank you for your understanding.";
  // const content =
  //   "Notice: The 11:30 PM live session will not take place for the next 3 days. Instead, a written session post will be published and updated on the website and app. The 9:30 PM live session will be held at its regular time.";

  return (
    <div className="marquee-container bg-purple py-2 text-white border-top border-bottom">
      <div className="marquee-content">
        {/* We repeat the text to ensure there is no gap during the loop */}
        <span className="marquee-text">{content}</span>
        <span className="marquee-text">{content}</span>
        <span className="marquee-text">{content}</span>
      </div>
    </div>
  );
};
const Marquee2 = () => {
  const content =
    "Welcome to WaqarZaka.net! Join our weekly New Subscriber Orientation to learn how to use the platform, access exclusive content, and make the most of your membership. Every Saturday at 5:00 PM & 9:00 PM PKT (12:00 PM & 4:00 PM UTC).";
  // "Dear Subscribers, Please be informed that tomorrow, Wednesday, August 26, 2026, all operations will remain closed in observance of Eid Milad-un-Nabi. This includes live sessions and all regular activities. Normal operations will resume afterward as scheduled. We wish you and your families a blessed and peaceful Eid Milad-un-Nabi Mubarak.";
  // "Independence Day – Live Session Update, 🇵🇰 Happy Independence Day, Pakistan! There will be no live session on 14th August 2026. Any further updates will be shared via app notifications. Thank you for your understanding!";
  // "Waqar Zaka Trades is now officially live on both WEEX and MEXC so verify your UID with a minimum balance to unlock full access and start trading.";
  // "📢 Orientation Session: Join us on Saturday, 1 August 2026, at 5:00 PM or 9:00 PM to learn how to use the WaqarZaka.net website and app, explore its key features, and get started with confidence. All new members are welcome.";

  return (
    <div className="marquee-container2">
      <div className="marquee-container bg-purple py-2 text-white border-top border-bottom">
        <div className="marquee-content">
          {/* We repeat the text to ensure there is no gap during the loop */}
          <span className="marquee-text">{content}</span>
          <span className="marquee-text">{content}</span>
          <span className="marquee-text">{content}</span>
        </div>
      </div>
    </div>
  );
};

const MonthlySession = ({ handleShowMonthly }) => {
  const alert = useAlert();
  const [loader, setLoader] = useState(false);

  const handleSubmit = async () => {
    try {
      setLoader(true);
      const stripeRes = await api.directPaySession();
      // console.log(stripeRes);

      if (!stripeRes?.link) {
        throw new Error("Something went wrong");
      }

      window.open(stripeRes?.link, "_self");

      setLoader(false);
    } catch (error) {
      alert.show(error?.message || "SOMETHING WENT WRONG.");
      setLoader(false);
    }
  };

  return (
    <>
      {loader ? (
        <Link
          // to={"/signup"}
          className="monthly socialL"
        >
          <i
            className="fa fa-spinner fa-pulse mx-2 mb-1"
            style={{ position: "relative", top: "-0px" }}
          ></i>
          MONTHLY GROUP
        </Link>
      ) : (
        <Link
          // to={"/signup"}
          className="monthly socialL"
          onClick={handleShowMonthly}
        >
          MONTHLY GROUP
        </Link>
      )}
    </>
  );
};
